import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import { ICaseDecision } from "../model/CaseDecision";
import CaseDecisionMapper from "../service/CaseDecisionMapper";
import CaseDecisionParamMapper from "../service/CaseDecisionParamMapper";

export default class GetAllCaseDecisionsInteractor {
  private resource: GetAllResourceEntriesInteractor<ICaseDecision>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute() {
    return this.resource.execute(
      "/case-decisions",
      CaseDecisionMapper,
      CaseDecisionParamMapper
    );
  }
}
